/**
 * ============================================================
 * TEMPLATE: Promoții - Echipamente
 * ============================================================
 *
 * Pentru a adăuga/modifica promoții la echipamente, editează array-ul de mai jos.
 * Fiecare echipament trebuie să aibă următoarele câmpuri:
 *
 *   name        – Numele echipamentului
 *   description – Descrierea în română și engleză
 *   image       – URL-ul imaginii
 *   oldPrice    – Prețul vechi (opțional, pentru afișarea reducerii)
 *   newPrice    – Prețul promoțional
 *   currency    – Moneda (ex: "EUR", "RON")
 *   condition   – Starea: "new" (nou) sau "used" (second-hand)
 *   year        – Anul de fabricație (opțional)
 *   specs       – Specificații tehnice cheie (opțional)
 *   inStock     – Dacă este disponibil (true/false)
 *   validUntil  – Data până la care este valabilă promoția (opțional)
 *
 * Exemplu:
 *   {
 *     name: "SmartPower 60 B8X",
 *     description: {
 *       ro: "Mașină de injecție servo-hidraulică, 60t forță de strângere.",
 *       en: "Servo-hydraulic injection machine, 60t clamping force.",
 *     },
 *     image: "https://example.com/image.jpg",
 *     oldPrice: 85000,
 *     newPrice: 72000,
 *     currency: "EUR",
 *     condition: "new",
 *     year: 2025,
 *     specs: "60t | Servo-hidraulic | B8X",
 *     inStock: true,
 *     validUntil: "2026-06-30",
 *   }
 * ============================================================
 */

export interface EquipmentPromotion {
  name: string;
  description: { ro: string; en: string };
  image: string;
  oldPrice?: number;
  newPrice: number;
  currency: string;
  condition: "new" | "used";
  year?: number;
  specs?: string;
  inStock: boolean;
  validUntil?: string;
}

export const equipmentPromotions: EquipmentPromotion[] = [
  // ── Adaugă echipamentele promoționale mai jos ──────────────
  {
    name: "Primus 116 EUROPACKAGE",
    description: {
      ro: "Pentru masini <strong>pana la 200 TF</strong>. Această <strong>OFERTĂ SPECIALĂ</strong> include urmatoarele optiuni: Capacitate de ridicare in configuratia actuala: 5kg; Nr vacuum:<strong>2</strong>; Nr griper:<strong>1</strong>; Pachet de siguranță EXTERN; Adaptor standard WITTMANN înălțime 600 mm; Placă adaptoare E18, impachetare  si transport DAP CLIENT.<br> <strong>ESTI INTERESAT ? SUNA-NE:<br>Bogdan Nestor - 0720.227.255<br>Edaurd Lazea - 0725.227.255</strong>",
      en: "For machines <strong>up to 200 TF</strong>. This <strong>SPECIAL OFFER</strong> includes the following options: Lifting capacity in current configuration: 5kg; No. of vacuums:<strong>2</strong>; No. of grippers:<strong>1</strong>; EXTERNAL safety package; WITTMANN standard adapter height 600 mm; E18 adapter plate, packaging and transport DAP CLIENT.<br> <strong>ARE YOU INTERESTED ? CALL US:<br>Bogdan Nestor - 0720.227.255<br>Edaurd Lazea - 0725.227.255</strong>",
    },
    image: "https://wittmann-group.ro/img.promo/Primus116.webp",
    oldPrice: 20200,
    newPrice: 12990,
    currency: "EUR+TVA",
    condition: "new",
    year: 2026,
    specs: "Z:1.500 | Y:1.200 | X:420 | C:pneumatic | Pret DAP Client",
    inStock: true,
    validUntil: "2026-04-09",
  },
  {
    name: "Primus 126T EUROPACKAGE",
    description: {
      ro: "Pentru masini <strong>pana la 400 TF</strong>. Această <strong>OFERTĂ SPECIALĂ</strong> include urmatoarele optiuni: Capacitate de ridicare in configuratia actuala: 8kg; Nr vacuum:<strong>2</strong>; Nr griper:<strong>1</strong>; Pachet de siguranță EXTERN; Adaptor standard WITTMANN înălțime 600 mm; Placă adaptoare E18, impachetare  si transport DAP CLIENT.<br> <strong>ESTI INTERESAT ? SUNA-NE:<br>Bogdan Nestor - 0720.227.255<br>Edaurd Lazea - 0725.227.255</strong>",
      en: "For machines <strong>up to 400 TF</strong>. This <strong>SPECIAL OFFER</strong> includes the following options: Lifting capacity in current configuration: 8kg; No. of vacuums:<strong>2</strong>; No. of grippers:<strong>1</strong>; EXTERNAL safety package; WITTMANN standard adapter height 600 mm; E18 adapter plate, packaging and transport DAP CLIENT.<br> <strong>ARE YOU INTERESTED ? CALL US:<br>Bogdan Nestor - 0720.227.255<br>Edaurd Lazea - 0725.227.255</strong>",
    },
    image: "https://wittmann-group.ro/img.promo/Primus126t.webp",
    oldPrice: 35600,
    newPrice: 26990,
    currency: "EUR+TVA",
    condition: "new",
    year: 2026,
    specs: "Z:2.500 | Y:1.400 | X:800 | C:pneumatic | Pret DAP Client",
    inStock: true,
    validUntil: "2026-04-09",
  },
  // ── Adaugă mai multe echipamente aici ──────────────────────
];
